module.exports = __webpack_public_path__ + "img/echo_sabre.aeffdbe5.png";